import React, {useEffect, useRef, useState} from "react";

import int1 from "../assets/images/intro/intro-1.jpg";
import int2 from "../assets/images/intro/intro-2.jpg";
import int3 from "../assets/images/intro/intro-3.jpg";
import int4 from "../assets/images/intro/intro-4.jpg";
import Intro1 from "../styles/components/intro/Intro1";
import Intro2 from "../styles/components/intro/Intro2";
import Intro3 from "../styles/components/intro/Intro3";
import Intro4 from "../styles/components/intro/Intro4";
import RightArrow from "./svg/RightArrow";

const data = [int1, int2, int3, int4];

const IntroScreen: React.FC<any> = ({setStateHasIntro}) => {
  const [i, setI] = useState(0);

  const scrollBottom = useRef<HTMLDivElement>(null);
  const scrollToBottom = () => {
    scrollBottom.current!.scrollIntoView({behavior: "smooth"});
  };

  useEffect(() => {
    setTimeout(() => {
      scrollToBottom();
    }, 500)
  }, []);

  return (
    <div className="intro-screen">
      {/*//ContentWrapper*/}
      <div className="intro-screen-holder">
        {/*Wrapper*/}
        <div
          className="intro-screen-holder__item"
          style={{
            transform: `translate(${i * 25}%)`,
          }}
        >
          {data.map((d, i) => (
            <div className={`intro-screen-holder__item--${i + 1}`} key={i}>
              <img src={d} alt="into"/>
              {i + 1 === 1 ? <Intro1/> : null}
              {i + 1 === 2 ? <Intro2/> : null}
              {i + 1 === 3 ? <Intro3/> : null}
              {i + 1 === 4 ? <Intro4/> : null}
              {/*<p>       rest {i + 1}</p>*/}
              {/*<div className="intro-screen-holder__contents">*/}
              {/*  <p>fsfouosfosdfoisdfosdfjosfosdfj</p>*/}
              {/*</div>*/}
            </div>
          ))}
        </div>

        {/*Dots*/}
        {/* <div className="intro-screen-holder__dots">
          {data.map((d, j) => (
            // dot
            <div className="intro-screen-holder__dots-dot"> </div>
          ))}
        </div> */}

        {/*content*/}
        <div className="intro-screen-holder__footer u-width-85" ref={scrollBottom}>
          <button
            className={`btn btn--primary small  ${i !== 3 ? "u-width-15" : "u-width-100"}`}
            onClick={() => {
              if (i === 3) {
                setStateHasIntro(true);
                localStorage.setItem("hasIntro", "yes");
              } else setI(i + 1);
            }}
          >
            {/* {i === 3 ? "مشاهده" :   "بعدی"} */}
            {i === 3 ? "مشاهده" : <RightArrow/>}
          </button>

          {i !== 3 ? (
            <span
              onClick={() => {
                setI(3);
              }}
            >
              رد کردن
            </span>
          ) : null}
        </div>

      </div>
    </div>
  );
};

export default IntroScreen;
